// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12J3Z","delete":"styles_delete__3blqS","update":"styles_update__q_5IY","add":"styles_add__P8Nr9"};